module.exports = __webpack_public_path__ + "static/media/Gorderums_Stenfæstning.8a1270ed.md";